import { Provincia } from ".";

export class Comune {
  id: number;
  nome: string;
  itemName: string;
  provincia: Provincia;
  sigla: string;
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/comune.ts